import { BusinessCategory } from 'constants/synergy';
import RedirectionCapability from 'hoc/RedirectionCapability';
import {
  CallbackPage,
  Case,
  CaseAddress,
  CaseIdentification,
  CaseIncidentDate,
  CaseIncidentDescription,
  CaseOpening,
  ConfirmationPage,
  Contact,
  ContactDetails,
  ContactUsPage,
  ContactUsAccidentPage,
  ContactUsCaseFailPage,
  ContactUsDuplicatePage,
  ContactUsMotorwayPage,
  CurrentNotification,
  CustomStep,
  DropOffPage,
  DropOffSuccessPage,
  ErrorPage,
  ExcludedPage,
  FAQPage,
  FlowSelector,
  FollowMyCase,
  HelpfulTips,
  History,
  IncidentDescription,
  Intro,
  LandingPage,
  LocationDetailsMapPage,
  LocationPage,
  MaintenanceDropOffPage,
  MobilityContinuationLocation,
  MobilityContinuationSummary,
  MobilityContinuationPresent,
  NotFound,
  OnGoingIcvcPage,
  OnGoingPage,
  PreviewPage,
  ReadOnlyHistory,
  ScheduleAppointment,
  SuccessPage,
  SummaryPage,
  SynergyAdditionalQuestions,
  SynergyConfirmationFollow,
  SynergyContactDetails,
  SynergyDestination,
  SynergyDestinationMap,
  SynergyIncidentDescription,
  SynergyIncidentUnderstood,
  SynergyPassengers,
  UploadPicturesFollowUp,
  UploadPicturesOpening,
  VehicleDetails,
  CaseVulnerabilitiesDescription,
  CaseIncidentInfo,
  SynergyBookAppointment,
  SynergyGarageOrientation,
  SynergyCoverageQuestions,
  MobilityContinuationConfirmation,
  PrismicChecker,
  MobilityContinuationCallback,
} from './LoadableComponents';

export const routes = {
  NOT_FOUND: '/not-found',
  MAINTENANCE: '/maintenance',
  NOT_FOUND_WITH_ID: '/:id/not-found',
  CASE_OPENING: '/',
  CALLBACK: '/ongoing',
  CALLBACK_POLICY_ERROR: '/ongoing_policy_error',
  CONFIRMATION: '/confirmation',
  GARAGE_ORIENTATION: '/garage_orientation',
  INCIDENT_DESCRIPTION: '/incident/description',
  INCIDENT_DATE: '/incident/date',
  INCIDENT_MORE: '/incident/more',
  INCIDENT_INFO: '/incident/info',
  INCIDENT_VULNERABILITIES: '/incident/vulnerabilities',
  INCIDENT_PHOTOS: '/incident/photos',
  IDENTIFICATION: '/identification',
  ADDRESS: '/address',
  CONTACT_DETAILS: '/contact_details',
  SUMMARY: '/summary',
  SUCCESS: '/success',
  ERROR: '/error',
  EXCLUDED: '/excluded',
  DROPOFF: '/dropoff',
  DROPOFF_SUCCESS: '/dropoff_success',
  PREVIEW: '/preview',
  GENERAL_PAGE: '/:id/:page',
  FLOW_SELECTOR: '/flow-selector',
  LOCATION: '/map',
  LOCATION_DETAILS_MAP: '/location-details-map',
  CONTACT_US: '/contact_us',
  CONTACT_US_ACCIDENT: '/contact_us/accident',
  CONTACT_US_CASE_CREATION_FAIL: '/contact_us/case_creation_fail',
  CONTACT_US_DUPLICATE: '/contact_us/duplicate',
  CONTACT_US_MOTORWAY: '/contact_us/motorway',
  PASSENGERS: '/passengers',
  CASE: '/case/:id',
  CONTACT: '/contact/:id',
  FAQ: '/faq/:id?',
  HELPFUL_TIPS: '/helpful_tips/:id?',
  HISTORY: '/history/:id',
  HISTORY_CASE: '/history-case/:id',
  HISTORY_DISABLED: '/history-readonly/:id',
  INTRO: '/intro/:id',
  NOTIFICATION: '/notification/:id',
  SCHEDULE_APPOINTMENT: '/schedule-appointment/:id',
  UPLOAD_PICTURES: '/upload-pictures/:id',
  VEHICLE_DETAILS: '/vehicle-details',
  FOLLOW_MY_CASE_ENTRY: '/follow-my-case',
  FOLLOW_MY_CASE_STATUS: '/case-status',
  SYNERGY_CONTACT_DETAILS: '/contact-details',
  SYNERGY_ADDITIONAL_QUESTIONS: '/additional-questions',
  MOBILITY_CONTINUITY_LOCATION: '/mobility-location-details',
  SYNERGY_INCIDENT_UNDERSTOOD: '/incident/understood',
  SYNERGY_COVERAGE_QUESTIONS: '/coverage-questions',
  SYNERGY_DESTINATION: '/destination',
  SYNERGY_DESTINATION_MAP: '/destination-map',
  SYNERGY_MOBILITY_CONTINUATION_PRESENT: '/mobility-continuation-present',
  SYNERGY_BOOK_APPOINTMENT: '/book-appointment',
  SYNERGY_FOLLOW_CONFIRMATION: '/confirmation-follow-up',
  MOBILITY_CONTINUATION_SERVICES: '/mobility-continuation-summary',
  MOBILITY_CONTINUATION_CONFIRMATION: '/mobility-continuation-confirm',
  MOBILITY_CONTINUATION_STATUS: '/mobility-continuation-status',
  PRISMIC_CHECKER: '/migration/check',
  MOBILITY_CONTINUATION_CALLBACK: '/mobility-continuation-callback',
};

export const commonRoutes = [
  {
    id: routes.FAQ,
    path: routes.FAQ,
    component: FAQPage,
    exact: true,
    name: 'faq',
  },
  {
    id: routes.HELPFUL_TIPS,
    path: routes.HELPFUL_TIPS,
    component: HelpfulTips,
    exact: true,
    name: 'helpful_tips',
  },
  {
    id: routes.MAINTENANCE,
    path: routes.MAINTENANCE,
    component: MaintenanceDropOffPage,
    exact: true,
    name: 'maintenance',
  },
];

const HISTORY = 'history';

const followUpRoutes = [
  {
    id: routes.NOTIFICATION,
    path: routes.NOTIFICATION,
    component: CurrentNotification,
    pageName: 'notification',
    exact: true,
  },
  {
    id: routes.HISTORY,
    path: routes.HISTORY,
    component: History,
    exact: true,
    name: HISTORY,
  },
  {
    id: routes.HISTORY_DISABLED,
    path: routes.HISTORY_DISABLED,
    component: ReadOnlyHistory,
    exact: true,
    name: HISTORY,
  },
  {
    id: routes.HISTORY_CASE,
    path: routes.HISTORY_CASE,
    component: History,
    exact: true,
    name: 'history-case',
  },
  {
    id: routes.NOT_FOUND,
    path: routes.NOT_FOUND,
    component: NotFound,
    exact: true,
  },
  {
    id: routes.SCHEDULE_APPOINTMENT,
    path: routes.SCHEDULE_APPOINTMENT,
    component: ScheduleAppointment,
    exact: true,
    name: 'schedule-appointment',
  },
  {
    id: routes.UPLOAD_PICTURES,
    path: routes.UPLOAD_PICTURES,
    component: UploadPicturesFollowUp,
    exact: true,
  },
  {
    id: routes.PREVIEW,
    path: routes.PREVIEW,
    component: PreviewPage,
  },
];

export const caseOpeningRoutes = [
  {
    id: routes.CASE_OPENING,
    path: routes.CASE_OPENING,
    component: CaseOpening,
    exact: true,
  },
  {
    id: routes.CONTACT_DETAILS,
    path: routes.CONTACT_DETAILS,
    component: ContactDetails,
    exact: true,
  },
  {
    id: routes.INCIDENT_DESCRIPTION,
    path: routes.INCIDENT_DESCRIPTION,
    component: IncidentDescription,
    exact: true,
  },
  {
    id: routes.INCIDENT_DATE,
    path: routes.INCIDENT_DATE,
    component: CaseIncidentDate,
    exact: true,
  },
  {
    id: routes.INCIDENT_MORE,
    path: routes.INCIDENT_MORE,
    component: CaseIncidentDescription,
    exact: true,
  },
  {
    id: routes.INCIDENT_INFO,
    path: routes.INCIDENT_INFO,
    component: CaseIncidentInfo,
    exact: true,
  },
  {
    id: routes.INCIDENT_VULNERABILITIES,
    path: routes.INCIDENT_VULNERABILITIES,
    component: CaseVulnerabilitiesDescription,
    exact: true,
  },
  {
    id: routes.INCIDENT_PHOTOS,
    path: routes.INCIDENT_PHOTOS,
    component: UploadPicturesOpening,
    exact: true,
  },
  {
    id: routes.IDENTIFICATION,
    path: routes.IDENTIFICATION,
    component: CaseIdentification,
    exact: true,
  },
  {
    id: routes.ADDRESS,
    path: routes.ADDRESS,
    component: CaseAddress,
    exact: true,
  },
  {
    id: routes.SUMMARY,
    path: routes.SUMMARY,
    component: SummaryPage,
    exact: true,
  },
  {
    id: routes.SUCCESS,
    path: routes.SUCCESS,
    component: SuccessPage,
    exact: true,
  },
  {
    id: routes.ERROR,
    path: routes.ERROR,
    component: ErrorPage,
    exact: true,
  },
  {
    id: routes.EXCLUDED,
    path: routes.EXCLUDED,
    component: ExcludedPage,
    exact: true,
  },
  {
    id: routes.DROPOFF,
    path: routes.DROPOFF,
    component: DropOffPage,
    exact: true,
  },
  {
    id: routes.DROPOFF_SUCCESS,
    path: routes.DROPOFF_SUCCESS,
    component: DropOffSuccessPage,
    exact: true,
  },
  {
    id: routes.CALLBACK,
    path: routes.CALLBACK,
    component: OnGoingPage,
    exact: true,
  },
  {
    id: routes.CALLBACK_POLICY_ERROR,
    path: routes.CALLBACK_POLICY_ERROR,
    component: OnGoingIcvcPage,
    exact: true,
  },
];

export const synergyRoutes = [
  {
    id: routes.CASE_OPENING,
    path: routes.CASE_OPENING,
    component: LandingPage,
    exact: true,
  },
  {
    id: routes.LOCATION,
    path: routes.LOCATION,
    component: LocationPage,
    exact: true,
  },
  {
    id: routes.LOCATION_DETAILS_MAP,
    path: routes.LOCATION_DETAILS_MAP,
    component: LocationDetailsMapPage,
    exact: true,
  },
  {
    id: routes.CALLBACK,
    path: routes.CALLBACK,
    component: CallbackPage,
    exact: true,
  },
  {
    id: routes.SUMMARY,
    path: routes.SUMMARY,
    component: SummaryPage,
  },
  {
    id: routes.CONFIRMATION,
    path: routes.CONFIRMATION,
    component: ConfirmationPage,
    exact: true,
  },
  {
    id: routes.FLOW_SELECTOR,
    path: routes.FLOW_SELECTOR,
    component: FlowSelector,
  },
  {
    id: routes.INCIDENT_DESCRIPTION,
    path: routes.INCIDENT_DESCRIPTION,
    component: SynergyIncidentDescription,
  },
  {
    id: routes.CONTACT_US,
    path: routes.CONTACT_US,
    component: ContactUsPage,
    exact: true,
  },
  {
    id: routes.CONTACT_US_ACCIDENT,
    path: routes.CONTACT_US_ACCIDENT,
    component: ContactUsAccidentPage,
  },
  {
    id: routes.CONTACT_US_CASE_CREATION_FAIL,
    path: routes.CONTACT_US_CASE_CREATION_FAIL,
    component: ContactUsCaseFailPage,
  },
  {
    id: routes.CONTACT_US_DUPLICATE,
    path: routes.CONTACT_US_DUPLICATE,
    component: ContactUsDuplicatePage,
  },
  {
    id: routes.CONTACT_US_MOTORWAY,
    path: routes.CONTACT_US_MOTORWAY,
    component: ContactUsMotorwayPage,
  },
  {
    id: routes.PASSENGERS,
    path: routes.PASSENGERS,
    component: SynergyPassengers,
  },
  {
    id: routes.SYNERGY_CONTACT_DETAILS,
    path: routes.SYNERGY_CONTACT_DETAILS,
    component: SynergyContactDetails,
  },
  {
    id: routes.VEHICLE_DETAILS,
    path: routes.VEHICLE_DETAILS,
    component: VehicleDetails,
  },
  {
    id: routes.FOLLOW_MY_CASE_ENTRY,
    path: routes.FOLLOW_MY_CASE_ENTRY,
    component: FollowMyCase,
  },
  {
    id: routes.SYNERGY_ADDITIONAL_QUESTIONS,
    path: routes.SYNERGY_ADDITIONAL_QUESTIONS,
    component: SynergyAdditionalQuestions,
  },
  {
    id: routes.MOBILITY_CONTINUITY_LOCATION,
    path: routes.MOBILITY_CONTINUITY_LOCATION,
    component: MobilityContinuationLocation,
  },
  {
    id: routes.SYNERGY_DESTINATION,
    path: routes.SYNERGY_DESTINATION,
    component: SynergyDestination,
  },
  {
    id: routes.SYNERGY_DESTINATION_MAP,
    path: routes.SYNERGY_DESTINATION_MAP,
    component: SynergyDestinationMap,
  },
  {
    id: routes.SYNERGY_BOOK_APPOINTMENT,
    path: routes.SYNERGY_BOOK_APPOINTMENT,
    component: SynergyBookAppointment,
  },
  {
    id: routes.SYNERGY_FOLLOW_CONFIRMATION,
    path: routes.SYNERGY_FOLLOW_CONFIRMATION,
    component: SynergyConfirmationFollow,
  },
  {
    id: routes.SYNERGY_INCIDENT_UNDERSTOOD,
    path: routes.SYNERGY_INCIDENT_UNDERSTOOD,
    component: SynergyIncidentUnderstood,
  },
  {
    id: routes.SYNERGY_MOBILITY_CONTINUATION_PRESENT,
    path: routes.SYNERGY_MOBILITY_CONTINUATION_PRESENT,
    name: 'mobility-continuation-present',
    component: MobilityContinuationPresent,
  },
  {
    id: routes.GARAGE_ORIENTATION,
    path: routes.GARAGE_ORIENTATION,
    component: SynergyGarageOrientation,
  },
  {
    id: routes.SYNERGY_COVERAGE_QUESTIONS,
    path: routes.SYNERGY_COVERAGE_QUESTIONS,
    component: SynergyCoverageQuestions,
  },
  {
    id: routes.MOBILITY_CONTINUATION_SERVICES,
    path: routes.MOBILITY_CONTINUATION_SERVICES,
    name: 'mobility-continuation-summary',
    component: MobilityContinuationSummary,
  },
  {
    id: routes.MOBILITY_CONTINUATION_CONFIRMATION,
    path: routes.MOBILITY_CONTINUATION_CONFIRMATION,
    component: MobilityContinuationConfirmation,
  },
  {
    id: routes.MOBILITY_CONTINUATION_CALLBACK,
    path: routes.MOBILITY_CONTINUATION_CALLBACK,
    component: MobilityContinuationCallback,
  },
  {
    id: routes.MOBILITY_CONTINUATION_STATUS,
    path: routes.MOBILITY_CONTINUATION_STATUS,
    component: null,
  },
];

const getRedirectionCapableRoute = (route, showMaintenanceDropOff) => ({
  ...route,
  component: RedirectionCapability(
    route.component,
    !showMaintenanceDropOff,
    routes.MAINTENANCE,
  ),
});

export const routesConfig = ({
  customCaseCreationSteps,
  showCaseCreationPage,
  showCasePage,
  showIntro,
  showContactPage,
  businessCategory,
  showMaintenanceDropOffOnCaseOpening,
  showMaintenanceDropOffOnFollowUp,
  showPrismicChecker,
}) => {
  const routesFromConfig = [
    ...commonRoutes,
    ...followUpRoutes.map(route =>
      getRedirectionCapableRoute(route, showMaintenanceDropOffOnFollowUp),
    ),
  ];
  showIntro &&
    routesFromConfig.push({
      id: routes.INTRO,
      path: routes.INTRO,
      component: RedirectionCapability(Intro, showIntro),
      exact: true,
    });
  showCasePage &&
    routesFromConfig.push({
      id: routes.CASE,
      path: routes.CASE,
      component: RedirectionCapability(
        Case,
        !showMaintenanceDropOffOnFollowUp,
        showMaintenanceDropOffOnFollowUp
          ? routes.MAINTENANCE
          : routes.NOT_FOUND,
      ),
      exact: true,
    });
  showPrismicChecker &&
    routesFromConfig.push({
      id: routes.PRISMIC_CHECKER,
      path: routes.PRISMIC_CHECKER,
      component: PrismicChecker,
      exact: true,
    });
  showContactPage &&
    routesFromConfig.push({
      id: routes.CONTACT,
      path: routes.CONTACT,
      component: Contact,
      exact: true,
      name: 'contact',
    });
  if (showCaseCreationPage) {
    const customRoutes = customCaseCreationSteps.map(({ path }) => ({
      id: path,
      path,
      component: CustomStep,
      exact: true,
    }));
    caseOpeningRoutes.unshift(...customRoutes);
    synergyRoutes.unshift(...customRoutes);
    businessCategory === BusinessCategory.MOTOR
      ? routesFromConfig.push.apply(routesFromConfig, synergyRoutes)
      : routesFromConfig.push.apply(
          routesFromConfig,
          caseOpeningRoutes.map(route =>
            getRedirectionCapableRoute(
              route,
              showMaintenanceDropOffOnCaseOpening,
            ),
          ),
        );
  }
  routesFromConfig.push(DEFAULT_HANDLER_ROUTE);
  return routesFromConfig;
};

const DEFAULT_HANDLER_ROUTE = {
  path: '*',
  id: '*',
  component: NotFound,
};

export default routes;
